import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { NgSelectModule } from "@ng-select/ng-select";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { TripService } from "src/app/services/core/distributions/trip/trip.service";
import { FundingSourceService } from "src/app/services/core/funding-source/funding-source.service";
import { MemberService } from "src/app/services/core/member/member.service";
import { sweetAlert } from "src/app/utils/swal";
@UntilDestroy()
@Component({
  selector: "app-file-parsing",
  templateUrl: "./member-parsing.component.html",
  styleUrls: ["./member-parsing.component.css"],
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
})
export class MemberParsingComponent implements OnInit {
  selectedFile: File | null = null;
  submitted = false;
  invalidFileType = false;
  selFundSrc: any = "";
  unParseMembers: any = [];
  fundingSources: any = [];
  constructor(
    private fundingSource: FundingSourceService,
    private memberService: MemberService,
    private router: Router
  ) {}
  ngOnInit() {
    this.getFundingSource();
  }
  submitFile() {
    this.submitted = true;
    if (this.selectedFile === null) {
      return;
    }
    this.memberService
      .parseMember(this.selectedFile, this.selFundSrc)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data) {
          this.unParseMembers = data.skippedMembers || [];
          if(data?.skippedMembers?.length == 0){
            this.router.navigateByUrl('/members');
          }
        }
      });
  }



  onFileSelection(event: any): void {
    const file: File = event.target?.files?.[0];

    if (!file) {
      this.selectedFile = null;
      return;
    }

    const allowedMimeTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-excel", // .xls
    ];

    const allowedExtensions = ["xlsx", "xls"];
    const fileExtension = file.name.split(".").pop()?.toLowerCase();

    const isValidType =
      allowedMimeTypes.includes(file.type) ||
      (fileExtension && allowedExtensions.includes(fileExtension));

    if (!isValidType) {
      this.selectedFile = null;
      this.invalidFileType = true;
      sweetAlert(
        "Error",
        "Invalid file type. Only Excel files (.xls or .xlsx) are allowed.",
        "error",
        "OK"
      );

      return;
    }

    this.selectedFile = file;
    this.invalidFileType = false;
  }

  deleteFile(fileInput: HTMLInputElement | null) {
    this.selectedFile = null;
    if (fileInput) {
      fileInput.value = "";
    }
  }

  getFundingSource() {
    this.fundingSource
      .getPicker({ isActive: true })
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
          this.fundingSources = data.results.sort((a: any, b: any) =>
            (a.title).toLowerCase().localeCompare((b.title).toLowerCase())
          );
          // this.preFundingSource = this.fundingSourceList.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }
}
